import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

document.addEventListener('DOMContentLoaded',function() {
    const button = document.querySelector(".scroll-form");

    const runScroll = function(el) {
        const offsetTop = document.querySelector(el).offsetTop;
        scroll({
            top: offsetTop-100,
            behavior: "smooth"
        })
    };

    const clickHandler = function(e) {
        e.preventDefault();
        runScroll('.js-target-scroll');
    };
    
    if (button) {
        button.addEventListener('click', clickHandler);        

        if (document.body.classList.contains('run-scroll')) {
            setTimeout(runScroll, 2000);
        }
    }
    

    const gtt = document.querySelectorAll("[data-target]");
    
    if (gtt.length > 0) {
        const action = function(e) {
                      
            const target = e.currentTarget.dataset.target;
            runScroll(target);
  
        	e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        };


        for (let i = 0; i < gtt.length; i++) {
            gtt[i].addEventListener('click', action);
        }
    }
    
}, false);
